import { PppcPolicySnapshot } from "@/types/pppc";
import { PppcPolicyCard } from "./PppcPolicyCard";
import { PppcPolicyRow } from "./PppcPolicyRow";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface PppcPolicyListProps {
  policies: PppcPolicySnapshot[];
  view: "grid" | "list";
  isLinkedToCatalog: (p: PppcPolicySnapshot) => boolean;
  resolveIcon?: (p: PppcPolicySnapshot) => string | null;
  onView: (p: PppcPolicySnapshot) => void;
  onEdit: (p: PppcPolicySnapshot) => void;
  onDuplicate: (p: PppcPolicySnapshot) => void;
  onDelete: (p: PppcPolicySnapshot) => void;
}

export const PppcPolicyList = ({
  policies,
  view,
  isLinkedToCatalog,
  resolveIcon,
  onView,
  onEdit,
  onDuplicate,
  onDelete,
}: PppcPolicyListProps) => {
  if (view === "grid") {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {policies.map((p) => (
          <PppcPolicyCard
            key={p.policyId}
            policy={p}
            linkedToCatalog={isLinkedToCatalog(p)}
            iconUrl={resolveIcon ? resolveIcon(p) : null}
            onView={() => onView(p)}
            onEdit={() => onEdit(p)}
            onDuplicate={() => onDuplicate(p)}
            onDelete={() => onDelete(p)}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>App</TableHead>
            <TableHead>Identifier</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Services</TableHead>
            <TableHead>Allow / Deny</TableHead>
            <TableHead>Source</TableHead>
            <TableHead>Updated</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {policies.map((p) => (
            <PppcPolicyRow
              key={p.policyId}
              policy={p}
              linkedToCatalog={isLinkedToCatalog(p)}
              iconUrl={resolveIcon ? resolveIcon(p) : null}
              onView={() => onView(p)}
              onEdit={() => onEdit(p)}
              onDuplicate={() => onDuplicate(p)}
              onDelete={() => onDelete(p)}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
